"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upcomingHearingsContract = exports.DeleteUpcomingHearingsResponse = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const resources_1 = require("./resources");
const upcoming_hearings_schemas_1 = require("./resources/upcoming-hearings.schemas");
const refine_1 = require("./util/refine");
const c = (0, core_1.initContract)();
const path = '/upcoming-hearings';
const DeleteUpcomingHearingsResponseSchema = zod_1.z.object({
    deletedCount: zod_1.z.number(),
});
exports.DeleteUpcomingHearingsResponse = DeleteUpcomingHearingsResponseSchema.refine((refine_1.is));
exports.upcomingHearingsContract = c.router({
    findUpcomingHearings: {
        method: 'GET',
        path: `${path}`,
        query: upcoming_hearings_schemas_1.UpcomingHearingsQueryParams,
        headers: resources_1.UserOrApiAuthHeadersSchema,
        responses: {
            [200]: upcoming_hearings_schemas_1.PaginatedUpcomingHearings,
        },
        summary: 'Search upcoming hearings within a court system',
    },
    deleteUpcomingHearings: {
        method: 'DELETE',
        path: `${path}`,
        query: upcoming_hearings_schemas_1.DeleteUpcomingHearingsParams,
        headers: resources_1.ApiAuthHeadersSchema,
        responses: {
            [200]: exports.DeleteUpcomingHearingsResponse,
        },
        summary: 'Delete upcoming hearings within a court system, location, and date range',
    },
}, {
    strictStatusCodes: true,
    validateResponseOnClient: true,
    commonResponses: (0, resources_1.errorResponses)(),
});
